import ChatService from '../service/chat/e3.viewer.chat.service';
import HelpService from '../service/help.service';
import {findAgents, connectToServer} from "service/socket";
import {configData} from "service/config.data";

const detectBrowser = require('a_common-folder/utils/detectBrowser');
require('./agent.call.scss');

export default class AgentCall {
    constructor(TranslateService, sceneID) {
        this._helpService = new HelpService();
        this._chatService = new ChatService();
        this._ably = null;
        this._channel = null;
        this._presence = null;
        this._roomID = null;
        this._sceneID = sceneID;
        this._geoipUrl = config.geoip_url;
        this._translateService = TranslateService;
        this._translate = TranslateService.translate.bind(TranslateService);
        this._location = this._helpService.location;
        this._ajaxCall = this._helpService.ajaxCall;
        this._isIosChrome = detectBrowser.isIosChrome;
    }

    _initCompanyRoom(disableE3live, playHandler) {
        this._playHandler = playHandler;
        this._disableE3live = disableE3live;

        const {ably,channel, presence} = connectToServer();
        this._ably = ably;
        this._channel = channel;
        this._presence = presence;

        return findAgents()
            .then((agents) => {
                this.agents = agents;
                this._createAgentBubble(agents);

            }).catch((err) => {
                console.error(err)
            })
    }

    showAgentBubble() {
        if(this.ifAgentsOnline()) document.getElementsByClassName('call-block')[0].classList.remove('hidden');
    }

    hideAgentBubble() {
        if(this.ifAgentsOnline()) document.getElementsByClassName('call-block')[0].classList.add('hidden');
    }

    _createAgentBubble(agents) {
        const containerBlock = document.querySelector('#e3-viewer');
        const {e3play, agent: {image_url}} = config;

        if (agents.length > 0 && !this._disableE3live) {
            containerBlock
                .appendChild(
                    this._prepareBubbleBody(
                        image_url,
                        this._translate('AVAILIABLE_FOR_LIVEVIEWING'),
                        this._translate('START_LIVE_CHAT'),
                        this._callToAgent.bind(this)
                    )
                );
        }else{
            if(e3play){
                containerBlock
                    .appendChild(
                        this._prepareBubbleBody(
                            image_url,
                            this._translate('AVAILIABLE_FOR_LIVEVIEWING_PRO'),
                            this._translate('PLAY_GUIDED_TOUR'),
                            function () {
                                this.hideAgentBubble();
                                this._playHandler();
                            }.bind(this)
                        )
                    );
            }
        }
    }

    showPlayE3PLay(playHandler, textTitle, textButton) {
        document.querySelector('#e3-viewer')
            .appendChild(
                this._prepareBubbleBody(
                    config.agent.image_url,
                    this._translate(textTitle),
                    this._translate(textButton),
                    function () {
                        this.hideAgentBubble();
                        playHandler();
                    }.bind(this)
                )
            );
    }

    _getScene() {
        var cur = this._sceneID;
        var i = config.scenes.length;
        var scene = {};

        while (i--) {
            if (config.scenes[i].id == cur) {
                scene = config.scenes[i];
            }
        }

        return scene
    }

    _callToAgent() {
        if (this._isIosChrome) {
            var template = '<p>' + this._translateService.translate('E3_LIVE_IOS_CHROME_ERROR_DESCR') + '</p>' +
                '<div id="copy" class="inviteUrl"><input type="text" class="copy-url" value="' + this._location.href + '"/><span class="copy copy-icon"></span></div>';

            this._modalService.showCreatedModal('alert', template, true, {
                'copy': {event: 'click', handler: this._helpService.copyToClipboard.bind(null, 'e3-viewer-modal', 'copy', this._location.href)}
            });
            return;
        }

        var roomID = this._helpService.generateUUID();
        // var url = this._helpService.createInteractiveLink(roomID) + '&sharelink=0';
        var url = this._helpService.createInteractiveLink(roomID);
        var scene = this._getScene();

        this._ajaxCall(this._geoipUrl)
            .then(function (res) {
                var data = JSON.parse(res);
                data.language = navigator.language || navigator.userLanguage;
                data.osName = DetectRTC.osName;
                data.isWebRTCSupported = DetectRTC.isWebRTCSupported;
                data.isMobileDevice = DetectRTC.isMobileDevice;

                this._channel.publish('message',
                    {
                        channel: configData.serverID,
                        message: {
                            code: 'calling',
                            url: url + '&callanswer=1',
                            data: data,
                            roomID: roomID,
                            groupIDs: configData.groupIDs,
                            thumbnail: window.location.protocol + '//' + window.location.hostname + scene.thumbnail,
                            title: config.title,
                            timestamp: new Date().getTime()
                        }
                    }, function () {
                        window.location.href = url + '&sharelink=0';
                    });
            }.bind(this))
            .catch(function (err) {
                console.error(err);
                var data = {};
                data.language = navigator.language || navigator.userLanguage
                this._channel.publish('message',
                    {
                        channel: configData.serverID,
                        message: {
                            code: 'calling',
                            url: url,
                            data: data,
                            roomID: roomID,
                            groupIDs: configData.groupIDs,
                            thumbnail: config.scenes.thumbnail,
                            title: config.title,
                            timestamp: new Date().getTime()
                        }
                    }, function () {
                        window.location.href = url;
                    });
            }.bind(this))
    }

    static prepareBubbleBody() {
        var e3live = document.createElement('div');
        e3live.id = 'e3live';

        var realtime = document.createElement('div');
        realtime.id = 'realtime';
        realtime.classList.add('realtime');

        var connectedVideoWrapper = document.createElement('div');
        connectedVideoWrapper.classList.add('connected-video-wrapper');
        connectedVideoWrapper.id = 'connected-video-wrapper';

        var videoWrapper = document.createElement('div');
        videoWrapper.classList.add('video-wrapper');
        videoWrapper.classList.add('video-tag-agent');
        videoWrapper.classList.add('playing');

        var videoTag = document.createElement('div');
        videoTag.classList.add('video-tag');

        var spinner = document.createElement('div');
        spinner.classList.add('spinner');

        videoWrapper.appendChild(videoTag);
        videoWrapper.appendChild(spinner);
        connectedVideoWrapper.appendChild(videoWrapper);
        realtime.appendChild(connectedVideoWrapper);
        e3live.appendChild(realtime);

        return e3live;
    }

    _prepareBubbleBody(url, bodyString='', btnString='', btnHandler=()=>{}) {
        var callBlock = document.createElement('div');
        callBlock.classList.add('call-block');

        var callAgentLogo = document.createElement('div');
        if (url == null) {
            callBlock.classList.add('connected-video-wrapper');
            callAgentLogo.classList.add('logo');
        } else {
            callAgentLogo.classList.add('call-block-img');
            callAgentLogo.style.backgroundImage = 'url(' + url + ')';
        }

        var callButton = document.createElement('button');
        callButton.classList.add('call-button');
        callButton.innerHTML = btnString;
        callButton.onclick = btnHandler;

        var bubble = this._chatService._chatBlock();

        var msg = this._chatService._createItemForMsg({msg: bodyString, userID: ''});
        msg.getElementsByClassName('triangle')[0].appendChild(callButton);
        bubble.appendChild(msg);
        var closeButton = document.createElement('div');
        closeButton.classList.add('chat-modal-close');
        closeButton.onclick = function (e) {
            e.preventDefault();
            this.hideAgentBubble();
        }.bind(this);

        bubble.getElementsByClassName('message')[0].appendChild(closeButton);
        bubble.appendChild(msg);

        callBlock.appendChild(callAgentLogo);
        callBlock.appendChild(bubble);

        return callBlock;
    }

    ifAgentsAvailable() {
        return !!this.agents.length;
    }

    ifAgentsOnline() {
        return document.getElementsByClassName('call-block').length;
    }
}
